// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".headline[data-v-4394c3e1]{display:flex;flex-direction:column;gap:16px}.headline__title[data-v-4394c3e1]{font-weight:700;font-size:32px;color:#ffffff}.headline__text[data-v-4394c3e1]{color:#ffffff}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
